export default __webpack_public_path__ + "static/media/img-0504-holy-see-premium-face.40ba6285.png";